<template>
	<div class="all">
		<div class="login">
			<div class="mtop" style="margin-top: 20px;">
				<img class="login-logo" src="../../public/logo.jpg" />
			</div>
			<div class="login-title">智慧残联服务管理平台</div>
			<el-form :model="form" ref="form" :rules="rules" style="margin-top: 20px;" :inline="false">
				<el-form-item class="mtop" prop="phone">
					<el-input v-model="form.phone" class="login-input" placeholder="请输入用户名">
						<el-button slot="prepend" icon="el-icon-user-solid"></el-button>
					</el-input>
				</el-form-item>
				<el-form-item prop="password" class="mtop">
					<el-input :type="!password_show?'password':'text'" v-model="form.password" class="login-input"
						placeholder="请输入密码">
						<el-button slot="prepend" icon="el-icon-question"></el-button>
						<i slot="suffix" @click="password_show=password_show?false:true"
							:class="password_show?'text-black':'xian'" class="el-icon-view el-input__icon"></i>
					</el-input>
				</el-form-item>
			</el-form>
			<div class="mtop">
				<el-button @click="login" class="login-btn" type="primary">登录</el-button>
			</div>
			<div class="jishuzhichi">日照职业技术学院©技术支持</div>
		</div>
	</div>
</template>

<script>
	import sm from "sm-crypto"
	export default {
		data() {
			var checkYzm = (rule, value, cb) => {
				if (value.toString().length != 4) {
					cb(new Error("验证码位数不对"));
				}
				cb();
			};
			return {
				password_show: false,
				form: {
					phone: "",
					password: "",
					yzm: ""
				},
				txyzm: {
					data: "",
					uuid: ""
				},
				rules: {
					phone: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 90,
							message: '密码不小于6位',
							trigger: 'blur'
						}
					]
				}
			}
		},
		methods: {
			login() {
				this.$refs["form"].validate((valid) => {
					if (valid) {
						let form = JSON.parse(JSON.stringify(this.form));
						let password = sm.sm2.doEncrypt(form.password,
							"02a9fa092d95434eea7998ee6fa25a0abeda98496575685063608815fd9da1eb5c", 1);
						form.password = password;
						axios.post(this.$url + "login/ulogin", form)
							.then(res => {
								if (res.data.status == 1) {
									this.$alert(res.data.msg, '错误', {
										confirmButtonText: '确定',
										callback: action => {
											this.$message({
												showClose: true,
												message: res.data.msg,
												type: 'error'
											});
										}
									});
									return;
								};
								if (res.data.status == 0) {
									this.$message({
										showClose: true,
										message: res.data.msg,
										type: 'success'
									});
									window.localStorage.setItem("info", JSON.stringify(res.data.info));
									window.localStorage.setItem("org", JSON.stringify(res.data.org));
									window.localStorage.setItem("tea_token", JSON.stringify(res.data.tea_token));
									this.$store.commit("settoken", res.data.info.uid);
									this.$store.commit("setinfo", res.data.info);
									this.$store.commit("setorg", res.data.org);
									this.$router.push("/admin/zonglan");
								}
							}).catch(e => {
								this.$message({
									showClose: false,
									message: "网络异常",
									type: 'error'
								});
							});
					} else {
						this.$message({
							showClose: false,
							message: "登录失败，请重试",
							type: 'error'
						});
						return false;
					}
				})
			},

		},
		created() {}
	}
</script>

<style>
	.text-black {
		color: black;
	}

	.xian {
		text-decoration: line-through;
		text-decoration-color: #aaaaaa;
	}

	.login-title {
		font-size: 20px;
		margin-top: 20px;
	}

	.login-input {
		width: 300px;
	}

	.login-btn {
		width: 300px;
	}

	.mtop {
		margin-top: 30px;
	}

	.all {
		width: 100vw;
		height: 100vh;
		background-image: url(/poster.jpg);
		background-repeat: no-repeat;
		background-size: cover;
		background-color: rgb(248, 248, 249);
		display: flex;
		justify-content: center;
		align-items: center;

	}

	.login {
		width: 400px;
		height: 600px;
		background-color: white;
		box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .1);
		border-radius: 4px;
		font-size: 14px;
		position: relative;
		transition: all .2s ease-in-out;
		padding: 0 16px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.login-logo {
		width: 50px;
		height: 50px;
	}

	.jishuzhichi {
		margin-top: 30px;
		font-size: 12px;
		color: gray;
	}
</style>